"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/ParticipantsPicker/SearchInput/Pill.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _Avatar = require('web/components/Avatar');
var _keyboard = require('web/services/keyboard');






const Pill = ({ entity, onRemove }) => (
  _react2.default.createElement('div', { className: "participants-picker--entity-pill", __self: this, __source: {fileName: _jsxFileName, lineNumber: 13}}
    , _react2.default.createElement(_Avatar.EntityAvatar, {
      size: 28,
      entity: entity,
      className: "participants-picker--entity-pill--avatar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 14}}
    )
    , _react2.default.createElement('span', { className: "participants-picker--entity-pill--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}}
      ,  entity.name 
    )
    , _react2.default.createElement('div', {
      role: "button", tabIndex: 0, onKeyDown: _keyboard.onButtonKeyDown,
      'aria-label': `Remove ${entity.name}`,
      onClick: () => onRemove(entity.entityKey),
      className: "participants-picker--entity-pill--remove-btn", __self: this, __source: {fileName: _jsxFileName, lineNumber: 22}}
    )
  )
)

exports. default = Pill
